<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>中国共产党纪律检查机关案件检查工作条例实施细则</h1>
        <div class="first">
          <p>(1994年3月25日)</p>
          <p>第一章</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
       <div class="xh"></div>
       

        <div class="second">
          <p>第一条 根据《中国共产党纪律检查机关案件检查工作条例》(以下简称《条例》)第四十九条的规定，制定本细则。</p>

          <p>第二条 《条例》第三条所称“纪检机关依照党章和本条例行使案件检查权”，是指纪律检查机关在党章和《条例》规定的职权范围内，对党员和党组织的违纪问题有权进行初步核实、立案和调查。</p>

          <p>任何国家机关、社会组织和个人均不得以违反法律、法规和党章、《条例》的手段，干扰、阻挠纪检机关的办案活动。对妨碍案件检查工作的，应按照《中共中央纪律检查委员会关于对妨碍违纪案件查处的党组织和党员党纪处分的规定(试行)》作出处理。</p>

          <p>第三条 《条例》第四条所称“事实清楚、证据确凿、定性准确、处理恰当、手续完备”是指：</p>

          <p>1 案件发生的时间、地点、手段、情节、后果和有关人员的责任等应清楚明确；</p>
          <p>2 认定的每一案件事实都应有经过鉴别属实的充分证据；</p>

          <p>3 确定错误性质和提出处理建议，均应以事实为依据，以党章、党纪和国家法律、法规为准绳；</p>

          <p>
            4 案件检查的各个环节都应符合《条例》和本细则规定的程序，并履行相应的手续；收集的证据和形成的案件材料也应符合规定的要求。
            第四条 根据《条例》第八条的规定，在案件检查中，纪检机关要切实保障党员和群众提出批评、检举、控告等项权利，保障被调查党员行使申辩、申诉等项权利，保障检举控告人、证人、被调查人和办案人不受打击报复。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
}
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>